/**
 * src/components/FriendlyErrorPage.tsx — the universal "oops" screen (web).
 *
 * Shared render for both error boundaries (App-level + route-level) so every
 * unhandled failure — DB down, Stripe down, a page crash — shows the same
 * friendly spider instead of a stark technical message. Covers customer,
 * driver, and admin surfaces. Ali's ask, 7/9 session.
 */

import { PrimaryButton } from "./ui";
import { OopsSpider } from "./ui/OopsSpider";

export function FriendlyErrorPage({
  actionLabel,
  onAction,
}: {
  actionLabel: string;
  onAction: () => void;
}) {
  return (
    <div
      role="alert"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "var(--space-3)",
        padding: "var(--space-6)",
        textAlign: "center",
        minHeight: "60vh",
      }}
    >
      <OopsSpider size={150} />
      <h2 style={{ fontSize: "var(--fs-xl)", fontWeight: 600, margin: 0 }}>
        Well, that wasn’t supposed to happen.
      </h2>
      <p style={{ color: "var(--color-text-muted)", maxWidth: 340, margin: 0, lineHeight: 1.55 }}>
        Something got tangled on our end. Your crates are safe — give it another try.
      </p>
      <div style={{ marginTop: "var(--space-3)" }}>
        <PrimaryButton onClick={onAction}>{actionLabel}</PrimaryButton>
      </div>
    </div>
  );
}
